/**
 * filterFiles - Filter files based on search query
 *
 * @param {Array} files - Array of file objects
 * @param {string} query - Search query
 * @returns {Array} - Filtered files
 */
export const filterFiles = (files, query) => {
  if (!query || query.trim() === '') {
    return files;
  }

  const lowerQuery = query.toLowerCase().trim();

  // Handle categorized format
  if (files.length > 0 && files[0]?.date) {
    return files
      .map((category) => ({
        ...category,
        attachments: category.attachments.filter((file) =>
          file.filename?.toLowerCase().includes(lowerQuery)
        ),
        count: category.attachments.filter((file) =>
          file.filename?.toLowerCase().includes(lowerQuery)
        ).length,
      }))
      .filter((category) => category.count > 0);
  }

  // Handle flat format
  return files.filter((file) => file.filename?.toLowerCase().includes(lowerQuery));
};
